import axios from "axios";
import {useSelector}from "react-redux" 
import { getDisplayName } from "recompose";
import  {publicClientApp} from '../index'
import {setAuthHeader} from "./setAuthHeader"

const msGraphToken="fhg48_UfGhra8_ph"

/*------------------Remainder: Errors and solutions ---------------------------
1) invalid request token  : verify axios request type :(post or get ...) or verify permessions in portal azure

-------------------------------------------------------------------*/


// get list of groupMember by groupid

export const apiGetListGroupMembers =async (id) => {
    await setAuthHeaderForMsGraph()
    let fmm_id="0492d63c-d158-43a4-93df-237689d5dabd"
 let msToken=localStorage.getItem(msGraphToken)
     return axios.get(`https://graph.microsoft.com/v1.0/groups/${fmm_id}/members`,
      {headers: { Authorization: 'Bearer ' + msToken }}
     );
 };

 // convertfiletoPdf with api msgraph//
 export const apiConvertToPdf=async()=>{
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
 return axios.get(` https://graph.microsoft.com/v1.0/me/drive/root:/Platforme_Enseignant/CV/cv_doc.docx:/content?format=pdf`,
  {headers : { Authorization: 'Bearer ' + msToken }})
 }

 // convertfiletoPdf with api msgraph//
 export const apiConvertWordToPdf=async(path)=>{
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
 return axios.get(` https://graph.microsoft.com/v1.0/me/drive/root:${path}:/content?format=pdf`,
  {headers : { Authorization: 'Bearer ' + msToken }})
 }

//-----------------------------Platforme_Enseignant/CV/cv_doc.docx 

export const apiUploadDocXFile =async (htmlString) => {  

    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    var fileBuffer = Buffer.from(htmlString);
     var bodyFormData = new FormData();
     let file= new File([fileBuffer], "cv_docx", { lastModified: new Date().getTime(), type: fileBuffer.type })
     bodyFormData.append('uploads', file)
     bodyFormData.append('token',msToken)
     console.log("file=====>:",bodyFormData)//null
     //the right method to get formData
     for (var key of bodyFormData.entries()) {
       console.log(key[0] + ', ' + key[1]);
   }
     return axios.post("/UploadCvDocx",bodyFormData,{headers: {'Content-Type': 'multipart/form-data' }}
    )
   };
   

// create cv folder and empty docx file
//  "/diploma/uploadEmptyDocx"

export const apiUploadSimpleFile =async (fileBuffer) => {

 await setAuthHeaderForMsGraph()
 let msToken=localStorage.getItem(msGraphToken)
  var bodyFormData = new FormData();
  let file= new File([fileBuffer], "cv_docx", { lastModified: new Date().getTime(), type: fileBuffer.type })
  bodyFormData.append('uploads', file)
  bodyFormData.append('token',msToken)
  console.log("file=====>:",bodyFormData)//null
  //the right method to get formData
  for (var key of bodyFormData.entries()) {
    console.log(key[0] + ', ' + key[1]);
}
  return axios.post("/UploadCvDocx",bodyFormData,{headers: {'Content-Type': 'multipart/form-data' }}
 )
};

// upload cv as PDF to oneDrive
export const apiUploadPDFFile =async (fileBuffer) => {

    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
     var bodyFormData = new FormData();
     let file= new File([fileBuffer], "cv_pdf", { lastModified: new Date().getTime(), type: fileBuffer.type })
     bodyFormData.append('uploads', file)
     bodyFormData.append('token',msToken)
     console.log("file=====>:",bodyFormData)//null
     //the right method to get formData
     for (var key of bodyFormData.entries()) {
       console.log(key[0] + ', ' + key[1]);
   }
     return axios.post("/UploadCvPDF",bodyFormData,{headers: {'Content-Type': 'multipart/form-data' }}
    )
   };

// create share link
export const apiCreateDiplomaImageShareLink=async(itemName)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    ///me/drive/items/{itemId}/createLink
    return axios.post(`https://graph.microsoft.com/v1.0/me/drive/root/${itemName}:/createLink`,
    {  type: "embed",
      // scope: "organization"
      },
    {headers : { Authorization: 'Bearer ' + msToken }})
}

// create share link for doc ecos
export const apiCreateEcosShareLink=async(path)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    const isId = !path.includes("/")
    const endpoint = isId
      ? `https://graph.microsoft.com/v1.0/me/drive/items/${path}/createLink`
      : `https://graph.microsoft.com/v1.0/me/drive/root:/${path}:/createLink`
    return axios.post(endpoint,
    {  
        //type: "view",
        type: "edit",
       //scope: "anonymous" // IS NOT ALLOWED BY UNIVERSTY OF TN 
       scope: "organization"
      },
    {headers : { Authorization: 'Bearer ' + msToken, 'Content-Type':'application/json' }})
}


export const apiCreateEcosShareLink_Attest=async(path)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    const isId = !path.includes("/")
    const endpoint = isId
      ? `https://graph.microsoft.com/v1.0/me/drive/items/${path}/createLink`
      : `https://graph.microsoft.com/v1.0/me/drive/root:/${path}:/createLink`
    return axios.post(endpoint,
    {  
        type: "view",
       // type: "edit",
       //scope: "anonymous" // IS NOT ALLOWED BY UNIVERSTY OF TN 
       scope: "organization"
      },
    {headers : { Authorization: 'Bearer ' + msToken, 'Content-Type':'application/json' }})
}
//---------------- create event calendar --------------------
//POST /users/{id | userPrincipalName}/calendar/events
export const apiCreateEventCalendar=async(userName)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    let sysToken=localStorage.getItem("comis-app-token")
    console.log("sysToken:",sysToken)
    console.log("mstoken:",msToken)
    ///me/drive/items/{itemId}/createLink  
    ///me/calendar/getSchedule     free/busy schedule
    //return axios.post(`https://graph.microsoft.com/v1.0/users/${userName}/calendar/events`,
    return axios.get(`https://graph.microsoft.com/v1.0/me/calendar/events`,
    //return axios.post(`https://graph.microsoft.com/v1.0/me/calendar/getSchedule`,
    {headers : { Authorization: 'Bearer ' + msToken }})
}

//-----------------------------------------------------------






//  create folder course
export const apiCreateFolderOneDrive=(data)=>{
   // await setAuthHeaderForMsGraph()
let msToken=localStorage.getItem(msGraphToken)
let sysToken=localStorage.getItem("comis-app-token")
setAuthHeader(sysToken)
return axios.post("/course/createFolder",{...data,token:msToken})
}

//---------Update------------/

export const apiUpdateItem=async(data,lastPath)=>{
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
 return axios.patch(`https://graph.microsoft.com/v1.0/me/drive/root:/${lastPath}`,
 data,
 {headers : { Authorization: 'Bearer ' + msToken }})
 }

//-----------------------------

// --------------------Delete Item ----------------
export const apiDeleteCourseFolder=async(folderName)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    
    return axios.delete(`https://graph.microsoft.com/v1.0/me/drive/root:/Platforme_Enseignant/Activités_pédagogiques/Enseignement/Universitaire/${folderName}`,
    
    {headers : { Authorization: 'Bearer ' + msToken }})
}

//----------------------------------------------------

// --------------------Delete File from courseFolder----------------
export const apiDeleteFileFromCourseFolder=async(folderName,itemName)=>{
    console.log("foldername:",folderName)
    console.log("itemName:",itemName)
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    
    return axios.delete(`https://graph.microsoft.com/v1.0/me/drive/root:/Platforme_Enseignant/Activités_pédagogiques/Enseignement/Universitaire/${itemName}`,
    
    {headers : { Authorization: 'Bearer ' + msToken }})
}

//----------------------------------------------------
// --------------------Delete File from one drive Folder----------------
export const apiDeleteFileFromFolder=async(path,itemName)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    
    return axios.delete(`https://graph.microsoft.com/v1.0/me/drive/root:/${path}/${itemName}`,
    
    {headers : { Authorization: 'Bearer ' + msToken }})
}



// --------------------Delete File from diplomaFolder----------------
export const apiDeleteFileFromDiplomaFolder=async(itemName)=>{
    
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    
    return axios.delete(`https://graph.microsoft.com/v1.0/me/drive/root:/Platforme_Enseignant/Titres et Diplômes/Diplômes/${itemName}`,
    
    {headers : { Authorization: 'Bearer ' + msToken }})
}

//----------------------------------------------------




// ------------------- Download item --------------
let path='/drive/root:/Platforme_Enseignant/Courses/React%20js3366/ترخيصn.jpg'
export const apiDownloadItem=async(path_to_file)=>{
    ///me/drive/root/search(q='{search-text}')
    //https://graph.microsoft.com/v1.0/users?$filter=startsWith(displayName,'J')
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    
    //29928BE0EBF6D645!265 // https://graph.microsoft.com/v1.0/me/drive/root:/{item-id}:/path_to_folder:/children/itemId_tobe_downloaded/content
    return axios.get(`https://graph.microsoft.com/v1.0/me${path}:/content`,
    //return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root:/${rootItemId}:/${path}:/children/${idOfItemToDownload}/content`,
 
    {headers : { Authorization: 'Bearer ' + msToken }})
}





// ----------------  Search item --------------------- work with some folder and some not!!!
export const apiSearchRootItemByName=async(name)=>{
    ///me/drive/root/search(q='{search-text}')
    //https://graph.microsoft.com/v1.0/users?$filter=startsWith(displayName,'J')
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    //search a specific folder by name in root  
return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root:/Platforme_Enseignant/Courses:/search(q='${name}')?$filter=name eq '${name}'`,
 //return axios.get(`https://graph.microsoft.com/beta/me/drive/root/search(q='Pictures')?$filter=name eq 'Pictures'`,
    {headers : { Authorization: 'Bearer ' + msToken }})
}
export const apiSearchItem_In_RootItemByName=async()=>{
    ///me/drive/root/search(q='{search-text}')
    //https://graph.microsoft.com/v1.0/users?$filter=startsWith(displayName,'J')
    await setAuthHeaderForMsGraph()
    let msToken=localStorage.getItem(msGraphToken)
    //search a specific folder by name in root
  return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root/p4uha/search(q='{courses}')?$filter=name eq 'courses'`,
    {headers : { Authorization: 'Bearer ' + msToken }})
}

//--------------------------------------------------

//Create about
export const apiGetPhotoCurrentAccount = async (username) => {
   await  setAuthHeaderForMsGraph()
    return axios.get(`https://graph.microsoft.com/beta/users/${username}/photo/$value`);
};
//https://graph.microsoft.com/v1.0/me/drive/root/children

//get list current-account files
export const apiGetListUsers =async () => {
    await setAuthHeaderForMsGraph()
 let msToken=localStorage.getItem(msGraphToken)
     return axios.get(`https://graph.microsoft.com/v1.0/users`,
      {headers: { Authorization: 'Bearer ' + msToken }}
     );
 };

//get list current-account files
export const apiGetListFilesByAccountName =async (userName,path) => {
    await setAuthHeaderForMsGraph()
 let msToken=localStorage.getItem(msGraphToken)
 try {
  let response= await  axios.get(`https://graph.microsoft.com/v1.0/users/${userName}/drive/root:/${path}:/children`,
      {headers: { Authorization: 'Bearer ' + msToken }}
     );
     return response
 }catch(err){
   
    console.error(err.response.status);  // ***
    
    return {data:{value:[]}}
 }
     
    
 };

//get list current-account files
export const apiGetListFilesCurrentAccount =async (rootItemId,path) => {
   await setAuthHeaderForMsGraph()
let msToken=localStorage.getItem(msGraphToken)
    return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root/children`,
     {headers: { Authorization: 'Bearer ' + msToken }}
    );
};
//get list courses folders
export const apiGetListCourseFolders =async (path) => {
    await setAuthHeaderForMsGraph()
  //  console.log("currentUser from microsoft api:",currentUser)
let msToken=localStorage.getItem(msGraphToken)
 //https://graph.microsoft.com/v1.0/me/drive/root:/${path}:/children/
     //return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root/Platforme_Enseignant/children`,
     return axios.get(`https://graph.microsoft.com/v1.0/me/drive/root:/${path}:/children`,
     {headers: { Authorization: 'Bearer ' + msToken }}
     );
 };
//GET https://graph.microsoft.com/beta/me/calendar

export const apiGetCalendarCurrentAccount = async() => {
   await setAuthHeaderForMsGraph()
    return axios.get(`https://graph.microsoft.com/beta/me/calendar`);
};



export const setAuthHeaderForMsGraph = async () => {
    if (localStorage.getItem("google_email")) return;
    //console.log("username localstorage:",localStorage.getItem("endhyeUz_n"))
    const currentAccount = publicClientApp.getAccountByUsername(localStorage.getItem("endhyeUz_n"));
    var request = {
        account: currentAccount,
        forceRefresh: false,
        scopes: ["User.Read","Files.ReadWrite","Calendars.ReadWrite"]
    };
    
  await  publicClientApp.acquireTokenSilent(request).then(tokenResponse => {
        // Do something with the tokenResponse
       // console.log("success quire token:",tokenResponse)
        if (tokenResponse.accessToken) {
            localStorage.setItem(msGraphToken,tokenResponse.accessToken)
           // axios.defaults.headers.common["Authorization"] = `Bearer ${tokenResponse.accessToken}`;
            
          } 
    }).catch(async (error) => {
        if (error) {
            console.log("error before aquiretokenPopup:", error)
            // fallback to interaction when silent call fails
            //return publicClientApp.acquireTokenPopup(request);
        }
    }).catch(error => {
       console.log("error token from apiMs:",error);
    });

    
  };

//   export const setAuthHeaderForMsGraph2 = () => {
//     const currentAccount = publicClientApp.getAccountByHomeId("00000000-0000-0000-2992-8be0ebf6d645.9188040d-6c67-4c5b-b112-36a304b66dad");
//     var request = {
//         account: currentAccount,
//     forceRefresh: false,
//     scopes: ["User.Read","Files.ReadWrite"]
//     };
    
//     publicClientApp.acquireTokenSilent(request).then(tokenResponse => {
//         // Do something with the tokenResponse
//         console.log("success aquiring token:",tokenResponse)
//         if (tokenResponse.accessToken) {
//             delete axios.defaults.headers.common["Authorization"];
//             axios.defaults.headers.common["Authorization"] = `Bearer ${tokenResponse.accessToken}`;
            
//           } else {
//             delete axios.defaults.headers.common["Authorization"];
//           }
//     }).catch(async (error) => {
//         if (error) {
//             console.log("error before aquiretokenPopup:", error)
//             // fallback to interaction when silent call fails
//             return publicClientApp.acquireTokenPopup(request);
//         }
//     }).catch(error => {
//        console.log("error token from apiMs:",error);
//     });

    
//   };
  
  // set auth header 